import classNames from 'classnames'

import type { FieldComponent } from 'services/content/components/types/FormModule'
import InputField from 'ui-component-library/components/00-Primitives/Inputs/InputField'
import TextArea from 'ui-component-library/components/00-Primitives/Inputs/TextArea'
import Dropdown from 'ui-component-library/components/00-Primitives/Inputs/Dropdown'
import DropdownCountryCode from 'ui-component-library/components/00-Primitives/Inputs/DropdownCountryCode'

import style from './style.scss'

type Props = {
  className?: string
  component: FieldComponent
  onChange: (value: string) => void
  value: string
}

function FormModuleField({ className, component, onChange, value }: Props) {
  const { fieldId, labelText, placeholder, isRequired } = component.props

  switch (component.name) {
    case 'Input':
      return (
        <InputField
          className={classNames(style.input, className)}
          label={labelText}
          inputId={fieldId}
          placeholder={placeholder}
          isRequired={isRequired}
          onUpdateField={onChange}
          value={value}
        />
      )
    case 'TextArea':
      return (
        <TextArea
          className={style.textArea}
          inputId={fieldId}
          isRequired={isRequired}
          label={labelText}
          placeholder={placeholder}
          updateField={onChange}
          value={value}
        />
      )
    case 'Dropdown': {
      const { options } = component.props
      return (
        <Dropdown
          className={style.dropdown}
          inputId={fieldId}
          isRequired={isRequired}
          label={labelText}
          placeholder={placeholder}
          options={options}
          handleOptionChange={onChange}
          selectedOption={value}
          variant='secondary'
        />
      )
    }

    case 'CountryDropdown':
      return (
        <DropdownCountryCode
          className={style.dropdown}
          inputId={fieldId}
          isRequired={isRequired}
          label={labelText}
          placeholder={placeholder}
          handleChange={(id, value) => onChange(value)}
          selectedOption={value}
          // selectedLanguage={selectedLanguage}
          variant='secondary'
        />
      )
    default:
      return null
  }
}

export default FormModuleField
